"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.default = exports.BannerHeader = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Image = _interopRequireDefault(require("../Image/Image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * BannerHeader component
 *
 * @method
 * @param {BannerHeaderProps} props
 * @returns BannerHeader
 */

const BannerHeader = props => {
  const {
    backgroundMedia,
    externalMedia
  } = props;
  if (!backgroundMedia && !externalMedia) {
    return null;
  }
  const componentClassName = (0, _classnames.default)('pal-c-BannerHeader');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, externalMedia && (0, _renderObject.renderObject)(externalMedia), !externalMedia && /*#__PURE__*/_react.default.createElement(_Image.default, {
    desktopImage: backgroundMedia?.desktopImage,
    tabletImage: backgroundMedia?.tabletImage,
    mobileImage: backgroundMedia?.mobileImage,
    altText: backgroundMedia?.altText,
    loading: backgroundMedia?.loading
  }));
};

/**
 * Property type definitions
 * @typedef BannerHeaderProps
 * @type {object}
 * @property {object} backgroundMedia - url, altText, ratio and loading prop for Image component
 * @property {object} externalMedia - url, altText, ratio and loading prop for external image or video
 */
exports.BannerHeader = BannerHeader;
const propTypes = exports.propTypes = {
  /**
   * Allows header prop to accept an object
   * **url** - string
   * **altText** - string
   * **loading** - string
   */
  backgroundMedia: _propTypes.default.object,
  /**
   * Allows header prop to accept an object of external media
   */
  externalMedia: _propTypes.default.object
};
BannerHeader.propTypes = propTypes;
var _default = exports.default = BannerHeader;